function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0706 2.35766C12.927 1.21411 11.073 1.21411 9.92942 2.35766L2.35766 9.92942C1.21411 11.073 1.21411 12.927 2.35766 14.0706L9.92942 21.6423C11.073 22.7859 12.927 22.7859 14.0706 21.6423L21.6423 14.0706C22.7859 12.927 22.7859 11.073 21.6423 9.92942L14.0706 2.35766ZM8.351 12.8291H17.6593C18.1177 12.8291 18.4927 12.4541 18.4927 11.9957C18.4927 11.5374 18.1177 11.1624 17.6593 11.1624H8.351L12.4177 7.09574C12.5737 6.94005 12.6614 6.72868 12.6614 6.50824C12.6614 6.28781 12.5737 6.07644 12.4177 5.92074C12.0927 5.59574 11.5677 5.59574 11.2427 5.92074L5.751 11.4124C5.426 11.7374 5.426 12.2624 5.751 12.5874L11.2427 18.0791C11.5677 18.4041 12.0927 18.4041 12.4177 18.0791C12.7427 17.7541 12.7427 17.2207 12.4177 16.8957L8.351 12.8291Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=PickupTicket.js.map